import { useLocale } from './LocaleContext.tsx';
import { strings, StringKey } from './strings.ts';

/**
 * `t(key)` for the interface locale resolved by `LocaleContext`.
 *
 * There is no fallback to English inside this hook on purpose: `strings`
 * is typed so that every locale has every key (see `strings.ts`), so a
 * missing translation is a build error caught long before this runs, not a
 * runtime default that hides a gap (ADR 0051 plan §2.1).
 */
export function useTranslation(): (key: StringKey) => string {
    const locale = useLocale();
    return (key: StringKey) => strings[locale][key];
}
